<template>
  <div class="page-header">
    <div class="container">
      <div class="row">
        <div class="col-xs-12">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactUs from '@/components/contact-us/ContactUs';

export default {
  name: 'PageHeader',
  components: {
    ContactUs
  }
};
</script>

<style lang="scss">
.page-header {
  padding: 30px 0 30px 0;
  margin: 0;

  h1 {
    font-size: 40px;
    margin: 0;
    line-height: 1.2;
    max-width: 600px;
    margin: auto;
    text-align: center;
  }

  p {
    font-size: 20px;
  }

  @media (max-width: 767px) {
    h1 {
      font-size: 20px;
    }

    p {
      font-size: 15px;
    }
  }
}
</style>
